const React = require("react");
const {
  account$,
} = require('../../../../../emitters/account');
const {Link} = require("../../../../../router");
const AppIcon = require("../../../../icons/Lunu");
const {USER_TYPE_MERCHANT, USER_TYPE_CUSTOMER} = require("../../../../../constants");
const {LINK_DASHBOARD, LINK_TRANSACTIONS} = require("../../../../../constants/links");
const withState = require('../../../../../utils/withState');

module.exports = withState(() => {
  return (state) => {
    const account = state.account || {};
    const indexLinks = {
      [USER_TYPE_MERCHANT]: LINK_DASHBOARD,
      [USER_TYPE_CUSTOMER]: LINK_TRANSACTIONS
    };

    const indexLink = account && indexLinks[account.account_type] || "";

    return(
      <div className="h140 h80@m layoutRow fhaS fvaC">
        <Link
          className="layoutRow fhaS fvaC tdN olN dn o70:h rlv"
          href={indexLink}
        >
          <AppIcon className="w128 mr20 rlv c0"/>
          <div className="rlv">
            <div className="abs svl layoutRow fhaC fvaC">
              <div
                className="c5B47FF fw3 f16 lh30 lts0em"
              >Console</div>
            </div>
          </div>
        </Link>
      </div>
    )
  }
}, {
  account: account$
})